export const notOfLegalAgeTemplateString = `
<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Age Restriction</title>
    <style>
        body {
            font-family: Helvetica, Arial, sans-serif;
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100vh;
            margin: 0;
        }
        .centered {
            text-align: center;
        }
    </style>
</head>
<body>
    <div class="centered">
        <h1>Oops</h1>
        <p>Sorry, this app can only be used by persons 18 and over.</p>
    </div>
</body>
</html>
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibm90T2ZMZWdhbEFnZVRlbXBsYXRlU3RyaW5nLmpzIiwic291cmNlUm9vdCI6Ii4vc3JjLyIsInNvdXJjZXMiOlsicGFja2FnZXMvc2hhcmVkL3NoYXJlZC1zaG9wL2NvbXBvbmVudHMvbW9iaWxlL25vdE9mTGVnYWxBZ2VUZW1wbGF0ZVN0cmluZy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxNQUFNLENBQUMsTUFBTSwyQkFBMkIsR0FBRzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztDQTRCMUMsQ0FBQyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBjb25zdCBub3RPZkxlZ2FsQWdlVGVtcGxhdGVTdHJpbmcgPSBgXG48IURPQ1RZUEUgaHRtbD5cbjxodG1sIGxhbmc9XCJlblwiPlxuPGhlYWQ+XG4gICAgPG1ldGEgY2hhcnNldD1cIlVURi04XCI+XG4gICAgPG1ldGEgbmFtZT1cInZpZXdwb3J0XCIgY29udGVudD1cIndpZHRoPWRldmljZS13aWR0aCwgaW5pdGlhbC1zY2FsZT0xLjBcIj5cbiAgICA8dGl0bGU+QWdlIFJlc3RyaWN0aW9uPC90aXRsZT5cbiAgICA8c3R5bGU+XG4gICAgICAgIGJvZHkge1xuICAgICAgICAgICAgZm9udC1mYW1pbHk6IEhlbHZldGljYSwgQXJpYWwsIHNhbnMtc2VyaWY7XG4gICAgICAgICAgICBkaXNwbGF5OiBmbGV4O1xuICAgICAgICAgICAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG4gICAgICAgICAgICBhbGlnbi1pdGVtczogY2VudGVyO1xuICAgICAgICAgICAgaGVpZ2h0OiAxMDB2aDtcbiAgICAgICAgICAgIG1hcmdpbjogMDtcbiAgICAgICAgfVxuICAgICAgICAuY2VudGVyZWQge1xuICAgICAgICAgICAgdGV4dC1hbGlnbjogY2VudGVyO1xuICAgICAgICB9XG4gICAgPC9zdHlsZT5cbjwvaGVhZD5cbjxib2R5PlxuICAgIDxkaXYgY2xhc3M9XCJjZW50ZXJlZFwiPlxuICAgICAgICA8aDE+T29wczwvaDE+XG4gICAgICAgIDxwPlNvcnJ5LCB0aGlzIGFwcCBjYW4gb25seSBiZSB1c2VkIGJ5IHBlcnNvbnMgMTggYW5kIG92ZXIuPC9wPlxuICAgIDwvZGl2PlxuPC9ib2R5PlxuPC9odG1sPlxuYDsiXX0=